namespace GeniuzPOS.Lookups {
    export interface VpsPaymenTypeRow {
        Paytype?: string;
        Code?: string;
        Detail?: string;
        Valuetype?: number;
        Value?: number;
        Pcamt?: number;
        Pcpc?: number;
        Name?: string;
    }

    export namespace VpsPaymenTypeRow {
        export const idProperty = 'Code';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Lookups.VpsPaymenType';
        export const lookupKey = 'VpsPaymenTypeRow';

        export function getLookup(): Q.Lookup<VpsPaymenTypeRow> {
            return Q.getLookup<VpsPaymenTypeRow>('VpsPaymenTypeRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Paytype = "Paytype",
            Code = "Code",
            Detail = "Detail",
            Valuetype = "Valuetype",
            Value = "Value",
            Pcamt = "Pcamt",
            Pcpc = "Pcpc",
            Name = "Name"
        }
    }
}
